// Never-On-Chain abbreviation
export const NOC = 'noc';
// Previously-On-Chain abbreviation
export const POC = 'poc';
export const PARTITION_DELIMITER = '::';
